var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradelockerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.985,
    height: 9.981,
    viewBox: "0 0 9.985 9.981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1980",
    "data-name": "Group 1980",
    transform: "translate(-19.268 -458.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M-17805.375-2551.621h1.523v-2.208h-9.984v2.314h1.711v-.857h6.75Z",
    transform: "translate(17833.104 3012.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M8.464,2.207H9.985V0H0V2.314H1.713V1.457H8.464Z",
    transform: "translate(29.253 468.257) rotate(180)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradelockerIcon);
export default __webpack_public_path__ + "static/media/tradelockerIcon.8afa03b7f65946b7dba263bd32d7076b.svg";
export { ForwardRef as ReactComponent };